import { DubovEngine } from './dubov.js';
import { ArenaEngine } from './arena.js';
import { BursteinEngine } from './burstein.js';
import { DutchEngine } from './dutch/engine.js';
import { DoubleSwissEngine } from './double-swiss.js';
import { KeizerEngine, LadderEngine, QuadsEngine } from './club.js';
import { KnockoutEngine } from './knockout.js';
import { LimEngine } from './lim.js';
import { MonradEngine } from './monrad.js';
import { RoundRobinEngine } from './roundrobin-engine.js';
import { UscfEngine } from './uscf.js';
import { PairingError, type PairingEngine } from './types.js';

const factories = new Map<string, () => PairingEngine>([
  ['dutch', () => new DutchEngine()],
  ['dubov', () => new DubovEngine()],
  ['burstein', () => new BursteinEngine()],
  ['monrad', () => new MonradEngine()],
  ['double-swiss', () => new DoubleSwissEngine()],
  ['keizer', () => new KeizerEngine()],
  ['arena', () => new ArenaEngine()],
  ['quads', () => new QuadsEngine()],
  ['ladder', () => new LadderEngine()],
  ['knockout', () => new KnockoutEngine(1)],
  ['knockout-2', () => new KnockoutEngine(2)],
  ['uscf', () => new UscfEngine()],
  ['lim', () => new LimEngine()],
  ['round-robin', () => new RoundRobinEngine(false)],
  ['double-round-robin', () => new RoundRobinEngine(true)],
]);

/** Register an engine factory under a pairing-system id (later registrations win). */
export function registerEngine(id: string, factory: () => PairingEngine): void {
  factories.set(id, factory);
}

export function getEngine(id: string): PairingEngine {
  const f = factories.get(id);
  if (f === undefined) {
    throw new PairingError(
      `no pairing engine for "${id}" (available: ${[...factories.keys()].join(', ')})`,
    );
  }
  return f();
}

export function engineIds(): string[] {
  return [...factories.keys()];
}
